// eslint-disable-next-line import/no-anonymous-default-export
export default {
  gender: 'Gender',
  'gender.child': "Child's Gender",
  age: 'Age',
  male: 'Male',
  female: 'Female',
  nonSmoker: 'Non Smoker',
  smoker: 'Smoker',
  smokingStatus: 'Smoking Status',
  'insured_target.label': "Who's covered",
  'insured_target.myself': 'Myself',
  'insured_target.family': 'My family',
  year: 'year',
  years: 'years',
  month: 'month',
  months: 'mo',
  // eslint-disable-next-line no-template-curly-in-string
  'coverage.annualLimit': 'Annual Limit<br></br> ${annualLimit}/year',
  // eslint-disable-next-line no-template-curly-in-string
  'coverage.lifetimeLimit': 'Lifetime Limit<br></br> ${lifetimeLimit}',
  'field.attribute_value': '{name}: {value}',
  comparePlans: 'Compare',
  planDetails: 'Plan Details',
  apply: 'Apply Now',
  'productMeta.accidentalMedical.description':
    'Without leaving personal information, you can estimate premiums of Bowtie Accidental Medical Plan - Touchwood Protector. Quote for free now!',
  'productMeta.vhis.description':
    'Without leaving personal information, you can estimate premiums of Bowtie VHIS Standard Plan and Flexi Plans. Quote for free now!',
  'productMeta.medical.description':
    'Without leaving personal information, you can estimate premiums of Cancer Medical Plan. Quote for free now!',
  'productMeta.life.description':
    'Without leaving personal information, you can estimate premiums of Term Life Plan. Quote for free now!',
  'productMeta.criticalIllness.description':
    'Without leaving personal information, you can estimate premiums of Term Critical Illness Plan. Quote for free now!',
  'productMeta.parent-medical.description':
    'Without leaving personal information, you can estimate premiums of Supplementary Medical Plan. Quote for free now!',
  'productMeta.accidentalMedical.name': 'Accidental Medical',
  'productMeta.vhis.name': 'VHIS',
  'productMeta.medical.name': 'Cancer Medical Plan',
  'productMeta.life.name': 'Term Life Plan',
  'productMeta.criticalIllness.name': 'Term Critical Illness Plan',
  'productMeta.parent-medical.name': 'Supplementary Medical Plan',
  'productMeta.title': ' - Premium Calculator | Bowtie',
  'coupon.title': 'Enter promotional code',
  'coupon.coupon_code': 'Enter promotional code',
  'coupon.message': 'Before {date}: {message}',
  'coupon.not_found': 'Invalid promotional code',
  'coupon.redeem': 'Submit',
  'coupon.save': 'save',
  'coupon.saved': 'saved',
  'coupon.save_tooltip': 'Clip Coupon to freeze this discount',
  'coupon.save_modal.title':
    "Grab it now to lock in your access – you'll have 14 days to decide!",
  'coupon.save_modal.subtitle':
    "We'll save it for you, just don't forget to come back and use it.",
  'coupon.save_modal.signup_button': 'Sign Up & Save',
  'coupon.save_modal.login_link': 'login',
  'coupon.coupon_options': 'View available promotional code(s)',
  'coupon.coupon_menu.title.header': 'Available promotional code(s)',
  'coupon.coupon_menu.title.saved': 'Saved',
  'coupon.coupon_menu.title.public': 'Public Offer',
  'coupon.coupon_menu.title.existing_customer':
    'For existing Bowtie customers only',
  'coupon.expired': 'Expired',
  'coupon.saved_extension': 'Saved with a {days}-day extension to',
  'coupon.save.error': 'Failed to save coupon. Please try again.',
  'invalid-age': 'Product cannot be issued for age {age}.',
  'sumAssured.label': 'Choose or enter sum assured',
  'deductible.label': 'Deductible (Please select)',
  'termLifeYear.label': 'Benefit Term',
  'termLifeYear.1': '1 Year (Premium adjusted annually)',
  'termLifeYear.5':
    '5 Years (5-year level premium, then adjusted by age upon renewal)',
  'termLifeYear.10':
    '10 Years (10-year level premium, then adjusted by age upon renewal)',
  'termLifeYear.20':
    '20 Years (20-year level premium, then adjusted by age upon renewal)',
  'invalid-sum-assured-range':
    'the sum assured must be between {min} and {max}',
  'term-and-conditions.1':
    'The monthly premiums above are for reference only. The actual premiums are affected by time, inflation, underwriting, Insurance Authority <a>levies</a> and other factors. ',
  'term-and-conditions.2':
    'For further details, please download and check the standard premium schedule. (<links></links>)',
  'term-and-conditions.3':
    'For further details, please download and check the <links></links>.',
  'term-and-conditions.vhis.standard': 'Standard',
  'term-and-conditions.vhis.flexi-regular': 'Flexi Regular',
  'term-and-conditions.vhis.flexi-plus': 'Flexi Plus',
  'term-and-conditions.vhis.flexi-premium-ward': 'Ward',
  'term-and-conditions.vhis.flexi-premium-semi-private': 'Semi-Private Room',
  'term-and-conditions.vhis.flexi-premium-private': 'Private Room',
  'term-and-conditions.medical.cancer-fighter-100': 'Cancer Fighter 100',
  'term-and-conditions.medical.cancer-fighter-200': 'Cancer Fighter 200',
  'term-and-conditions.medical.cancer-fighter-300': 'Cancer Fighter 300',
  'term-and-conditions.accidental-medical.touch-wood-protector':
    'standard premium schedule',
  'term-and-conditions.life.term-life':
    'Bowtie Term Life standard premium schedule (HK$1,000,000 Sum Insured)',
  'term-and-conditions.life.term-level-life-5':
    'Bowtie Term Life (5 Year plan) standard premium schedule (HK$1,000,000 Sum Insured)',
  'term-and-conditions.life.term-level-life-10':
    'Bowtie Term Life (10 Year plan) standard premium schedule (HK$1,000,000 Sum Insured)',
  'term-and-conditions.life.term-level-life-20':
    'Bowtie Term Life (20 Year plan) standard premium schedule (HK$1,000,000 Sum Insured)',
  'term-and-conditions.life.last-wish-rider':
    'Last Wish Rider standard premium schedule (HK$300,000 Sum Insured)',
  'term-and-conditions.life.last-wish-rider-5':
    'Last Wish Rider (5 Year plan) standard premium schedule (HK$300,000 Sum Insured)',
  'term-and-conditions.life.last-wish-rider-10':
    'Last Wish Rider (10 Year plan) standard premium schedule (HK$300,000 Sum Insured)',
  'term-and-conditions.life.last-wish-rider-20':
    'Last Wish Rider (20 Year plan) standard premium schedule (HK$300,000 Sum Insured)',
  'term-and-conditions.critical-illness.term-ci':
    'Bowtie Term Critical Illness',
  'term-and-conditions.critical-illness.term-ci-plus':
    'Bowtie Term Critical Illness Multiple Cover',
  'term-and-conditions.critical-illness.term-ci-max':
    'Term CI - Early Stage and Multiple Cover',
  'term-and-conditions.critical-illness.bb-ci': 'standard premium schedule',
  'term-and-conditions.critical-illness.juvenile-ci':
    'standard premium schedule',
  'term-and-conditions.parent-medical.parent-medical-standard': 'Basic',
  'term-and-conditions.parent-medical.parent-medical-advance': 'Advance',
  'term-and-conditions.social-proof.vhis-flexi-regular':
    'According to internal data, as of 31 December 2023, Bowtie VHIS - Flexi Regular Plan is chosen by the most people aged between {min_age} to {max_age} years old ({percentage}%). Calculation based on the number of policyholders enrolled in "Standard Plan", "Flexi Regular" and "Flexi Plus" across the same age cohort.',
  'term-and-conditions.social-proof.vhis-flexi-premium-semi-private':
    'According to internal data, as of 31 December 2023, Bowtie Pink VHIS (Semi-Private) is chosen by the most people aged between {min_age} to {max_age} years old ({percentage}%). Calculation based on the number of policyholders enrolled in "Bowtie Pink VHIS" across the same age cohort.',
  'term-and-conditions.social-proof.term-ci-max':
    'According to internal data, from 1 January 2024 to 13 May 2024, Bowtie Term CI - Early Stage and Multiple Cover is chosen by the most people aged between {min_age} to {max_age} years old ({percentage}%). Calculation based on the number of policyholders enrolled in "Bowtie Term CI" across the same age cohort.',
  'term-and-conditions.social-proof.cancer-fighter-300':
    'According to internal data, as of 31 December 2023, Bowtie Cancer Fighter 3M is chosen by the most people aged between {min_age} to {max_age} years old ({percentage}%). Calculation based on the number of policyholders enrolled in "Bowtie Cancer Fighter" across the same age cohort.',
  'link.ia.levy':
    'https://www.ia.org.hk/en/aboutus/role/financial_arrangements.html#1',
  'link.vhis.standard':
    'https://www.bowtie.com.hk/assets/product/vhis-standard/Premium-Schedule-Standard-03-EN.pdf',
  'link.vhis.flexi-regular':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi/Premium-Schedule-Flexi-Regular-05-EN.pdf',
  'link.vhis.flexi-plus':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi/Premium-Schedule-Flexi-Plus-05-EN.pdf',
  'link.vhis.flexi-premium-ward':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi-premium/Premium-Schedule-Bowtie-Pink-Ward-01.pdf',
  'link.vhis.flexi-premium-semi-private':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi-premium/premium-schedule-bowtie-pink-semi-private-02.pdf',
  'link.vhis.flexi-premium-private':
    'https://www.bowtie.com.hk/assets/product/vhis-flexi-premium/premium-schedule-bowtie-pink-private-02.pdf',
  'link.medical.cancer-fighter-100':
    'https://www.bowtie.com.hk/assets/product/cancer-fighter/Premium-Schedule-Cancer-Fighter-100-01.pdf',
  'link.medical.cancer-fighter-200':
    'https://www.bowtie.com.hk/assets/product/cancer-fighter/Premium-Schedule-Cancer-Fighter-200-01.pdf',
  'link.medical.cancer-fighter-300':
    'https://www.bowtie.com.hk/assets/product/cancer-fighter/Premium-Schedule-Cancer-Fighter-300-01.pdf',
  'link.accidental-medical.touch-wood-protector':
    'https://www.bowtie.com.hk/assets/product/touch-wood-protector/Premium-Schedule-Touch-Wood-Protector-01.pdf',
  'link.life.term-life':
    'https://www.bowtie.com.hk/assets/product/term-life/Premium-Schedule-Term-Life-$1,000,000-03.pdf',
  'link.life.term-level-life-5':
    'https://www.bowtie.com.hk/assets/product/level-term-life/Premium-Schedule-Level-Term-Life-$1,000,000-01.pdf',
  'link.life.term-level-life-10':
    'https://www.bowtie.com.hk/assets/product/level-term-life/Premium-Schedule-Level-Term-Life-$1,000,000-01.pdf',
  'link.life.term-level-life-20':
    'https://www.bowtie.com.hk/assets/product/level-term-life/Premium-Schedule-Level-Term-Life-$1,000,000-01.pdf',
  'link.critical-illness.term-ci':
    'https://www.bowtie.com.hk/assets/product/term-ci/Premium-Schedule-Term-Critical-Illness-500,000-02.pdf',
  'link.critical-illness.term-ci-plus':
    'https://www.bowtie.com.hk/assets/product/term-ci-plus/Premium-Schedule-Term-CI-Multiple-Cover-500,000-02.pdf',
  'link.critical-illness.term-ci-max':
    'https://www.bowtie.com.hk/assets/product/term-ci-max/Premium-Schedule-Term-CI-Early-Stage-Multiple-Cover-500,000-02.pdf',
  'link.life.last-wish-rider':
    'https://www.bowtie.com.hk/assets/product/lastwish/Premium-Schedule-Last-Wish-Rider-300%2C000-01.pdf',
  'link.life.last-wish-rider-5':
    'https://www.bowtie.com.hk/assets/product/lastwish/Premium-Schedule-Level-Last-Wish-Rider-300,000-01.pdf',
  'link.life.last-wish-rider-10':
    'https://www.bowtie.com.hk/assets/product/lastwish/Premium-Schedule-Level-Last-Wish-Rider-300,000-01.pdf',
  'link.life.last-wish-rider-20':
    'https://www.bowtie.com.hk/assets/product/lastwish/Premium-Schedule-Level-Last-Wish-Rider-300,000-01.pdf',
  'riders.title': 'Extra Coverage (Optional)',
  'riders.title.vhis': 'Wellness Package add-on (valued at $4,220) ',
  'riders.details.vhis': 'Details',

  'marketing-page-anchor-link.recommendation.description.vhis':
    'No decision yet? ',
  'marketing-page-anchor-link.recommendation.description.life':
    'How much is enough? ',
  'marketing-page-anchor-link.recommendation.description.critical-illness':
    'How much is enough? ',
  'marketing-page-anchor-link.vhis-product-choices.description.vhis':
    'No decision yet? ',
  'marketing-page-anchor-link.term-level-life-premium-explanation.description.life':
    ' ',
  'marketing-page-anchor-link.recommendation.link.vhis':
    'Our actuary will give you idea',
  'marketing-page-anchor-link.recommendation.link.life':
    'Our actuary will calculate the sum assured for you',
  'marketing-page-anchor-link.recommendation.link.critical-illness':
    'Our actuary will calculate the sum assured for you',
  'marketing-page-anchor-link.vhis-product-choices.link.vhis':
    'Which VHIS product suits you the most',
  'marketing-page-anchor-link.term-level-life-premium-explanation.link.life':
    'Pick the right benefit term for you',

  'social-proof-message': '🔥Top pick by {percentage}% of peers',

  'level-term-life-price-difference.message':
    '🔥 Save {percentage}% vs annual renewal*',
  'level-term-life-price-difference.remarks':
    '*Calculated based on standard premiums, excluding other promotional discounts; for reference only.',

  'counter.second': 'Second',
  'counter.minute': 'Minute',
  'counter.hour': 'Hour',
  'counter.day': 'Day',

  'variable_attribute.flexi.title': 'Flexi',
  'variable_attribute.pink.title': 'Bowtie Pink',
  'variable_attribute.pink.remark': 'Deductible',

  'age.option_label.unborn': 'Unborn (18-31 weeks)',
  'age.option_label.0': '0 (from 15 days)',
};
